import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

export type PostIncidentLogExportRequest = DateRangeQueryParams & {
	applicationId?: number;
};

export type PostIncidentLogExportResponse = { id: number };

export const postIncidentLogExportStart = createPostEndpoint<
	PostIncidentLogExportRequest,
	PostIncidentLogExportResponse
>('/api/v3/core/exports/incident-log/export/start');
